import { useEffect, useState } from "react";
import { History, ChevronDown } from "lucide-react";
import { api } from "@/lib/apiClient";
import { ReleaseItem } from "@/components/ReleaseItem";

// Storico aggiornamenti nella Guida: solo per chi è autorizzato a vedere le novità.
export function ReleaseHistory() {
  const [notes, setNotes] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/release-notes/history").then(({ data }) => setNotes(data)).catch(() => setNotes([])); }, []);
  if (!notes.length) return null;
  return (
    <section className="rounded-2xl border bg-white p-6" data-testid="release-history">
      <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-terracotta"><History className="h-4 w-4" />Storico aggiornamenti</div>
      <h2 className="mt-1 font-heading text-lg font-semibold text-forest">Tutte le novità del Portale</h2>
      <div className="mt-4 divide-y">
        {notes.map((n) => (
          <div key={n.revision} data-testid={`history-${n.revision}`}>
            <button onClick={() => setOpen(open === n.revision ? null : n.revision)} data-testid={`history-toggle-${n.revision}`}
              className="flex w-full items-center justify-between gap-3 py-3 text-left">
              <span>
                <span className="text-xs font-semibold text-muted-foreground">Aggiornamento n. {n.revision} · {n.date}</span>
                <span className="block font-medium text-forest">{n.title}</span>
              </span>
              <ChevronDown className={`h-4 w-4 shrink-0 text-forest transition-transform ${open === n.revision ? "rotate-180" : ""}`} />
            </button>
            {open === n.revision && (
              <ul className="space-y-2 pb-4">
                {n.items.map((t, i) => <ReleaseItem key={i} item={t} testid={`history-item-${n.revision}-${i}`} />)}
              </ul>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
